import type { Auth0ClientOptions } from '@auth0/auth0-spa-js'

const auth0Config: Auth0ClientOptions = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    scope: 'offline_access',
    redirect_uri: `${window.location.origin}/`,
  },
}

export default auth0Config

